import React, { Fragment } from "react";
import ReactHtmlParser from "react-html-parser";
import { useArticlesBoxes } from "../../hooks/useArticlesBoxes";
import * as S from "./ArticleContent.sc";
import Ado from "../Ado/Ado";
import AdoCodes from "../Ado/AdoConfig.json";
import TopicsCovered from "./TopicsCovered";
import TableOfContent from "./TableOfContent";
import { v4 as uuidv4 } from "uuid";

const ArticleContent = ({ site, article, id, topics, tableOfContentData }) => {
  const data = article[site - 1] || [];
  const userId = process.env.userId;
  const { poll, video, product } = useArticlesBoxes(id, userId);
  return (
    <Fragment>
      <div className="wysiwyg">
        {topics || tableOfContentData ? (
          <S.LeftBoxContaiener>
            {topics && <TopicsCovered topics={topics} />}
            {tableOfContentData && (
              <TableOfContent content={tableOfContentData} />
            )}
          </S.LeftBoxContaiener>
        ) : null}
        {data.map((content, i) => (
          <React.Fragment key={uuidv4()}>
            {i === 1 && (
              <S.BoxContaiener>
                <Ado {...AdoCodes.id01articleInContent} />
              </S.BoxContaiener>
            )}
            {i === 2 && (
              <S.BoxContaiener>
                <Ado {...AdoCodes.id02articleInContent} />
              </S.BoxContaiener>
            )}
            {ReactHtmlParser(content)}
          </React.Fragment>
        ))}
      </div>
      {video && <VideoElement video={video} />}
    </Fragment>
  );
};

const VideoElement = ({ video }) => {
  if (video.can_watch) {
    return (
      <>
        <S.VideoHeader>{video.name}</S.VideoHeader>
        <S.Video controls>
          <source src={video.movie} type="video/mp4"></source>
        </S.Video>
      </>
    );
  } else {
    return null;
  }
};

export default ArticleContent;
